<template>
    <section class="view">
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">Кто спросил</th>
                    <th class="text-left">Вопрос</th>
                    <th class="text-left">Ответ</th>
                    <th class="text-right"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in FAQ" :key="item.id">
                    <td>
                        <span v-if="item.person_type == 1">Преподаватель</span>
                        <span v-if="item.person_type == 0">Студент</span>
                    </td>
                    <td>{{ item.question }}</td>
                    <td>{{ item.answer }}</td>
                    <td class="text-right">

                        <v-menu>
                            <template v-slot:activator="{ on, attrs }" >
                                <v-icon
                                        class="context-menu"
                                        v-bind="attrs"
                                        v-on="on"
                                >
                                    mdi-dots-vertical
                                </v-icon>
                            </template>

                            <v-list>
                                <v-list-item @click="deleteReport(item.id)" >
                                    <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
                                    <v-list-item-title>Удалить</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-btn
                :key="'add'"
                :color="'green'"
                fab
                large
                dark
                bottom
                right
                class="v-btn--example"
                fixed
                @click="FAQAdder = true"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-overlay :value="FAQAdder" @click="reportAdder = false">
            <f-a-q-adder :closer="closeAdder"></f-a-q-adder>
        </v-overlay>

    </section>

</template>

<script>
    import {HTTP} from "../../axios";
    import FAQAdder from "../../components/controlpanel/FAQAdder";

    export default {
        components:{
            FAQAdder
        },
        name: "FAQ",
        data(){
            return{
                FAQ: [],
                FAQAdder: false
            }
        },
        computed: {
            activeFab () {
                switch (this.tabs) {
                    case 'one': return { color: 'success', icon: 'share' }
                    case 'two': return { color: 'red', icon: 'edit' }
                    case 'three': return { color: 'green', icon: 'keyboard_arrow_up' }
                    default: return {}
                }
            },
        },
        methods:{
            update(){
                HTTP
                    .get("FAQ")
                    .then(r=>{
                        this.FAQ = r.data.FAQ
                    })
            },
            closeAdder(){
                this.FAQAdder = false
                this.update()
            },
            deleteReport(id){
                var sure = confirm("Вы уверены?")
                if(!sure){
                    return false
                }

                HTTP
                    .delete("FAQ/" + id)
                    .then(()=>{
                        this.update()
                    })
            }
        },
        mounted(){
            this.update()
        }
    }
</script>

<style scoped>

</style>